module.exports = __webpack_public_path__ + "static/media/project-1.f69444ac.jpg";